import React from "react";
import { Header, Faq, SubFooter } from "Atoms/";

export default function faq() {
  return (
    <>
      <Header
        classType="header-int"
        title1="Waiʻānapanapa"
        title2="State Park"
        url="waianapanapa"
      />
      <div className="container" role="main">
        <div className="row row-padding">
          <div className="col-xl-12">
            <h2>FAQ about Waiʻānapanapa State Park</h2>
            <p>
              <hr />
              <h3 className="h4 fw-bold">What time does the park open?</h3>
              The park opens at 7:00a.m.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">When is the last reservation?</h3>
              The last reservation is at 6:00p.m.  You must enter the park no later than 5:30p.m.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">What time are reservations released?</h3>
              Reservations are released 30 days in advance, one day at a time, at midnight HST.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">Do I need a reservation, and do I purchase my parking and/or entry fees before I arrive?</h3>
              Yes
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                I have young children.  Do I need to pay for them also?
              </h3>
              Children three (3) years old or younger do not need to pay.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">Do you accept visitors without reservations?</h3>
              No.  Anyone without a reservation will be turned away (except residents with valid Hawai’i State ID).
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">Do you offer military discounts?</h3>
              Unfortunately, currently, we do not.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">Does my Parking reservation provide Entry to ALL passengers within the vehicle?</h3>
              You must select the number passengers in your vehicle with the vehicle parking reservation.  On the Start Order page, select parking, select the date/time you wish to reserve more than one time slot for a given day, enter all the times you wish a parking voucher for and then select the number of passengers from the select quantity drop down menu.  You will only be charged for the entries once and parking will be charged at $10.00 per time slot.<br/><br />
              If you wish to reserve more than one time slot for a given day, enter all the times you wish a parking voucher for and then select the number of passengers from the select quantity drop down menu.  You will only be charged for the entries once the parking will be charged at $10.00 per time slot.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                Can I cancel my trip and get a refund, or change the date of my visit after I’ve purchased my reservation?
              </h3>
              Refunds/Changes policies: Refunds are allowed up to 3 days prior to your entry date.  Changes to your reservation may be made up until the day before your reservation (midnight Hawai’i time) and will be allowed so long as space is available on your preferred date/time.  Cancellation ($5) and service fees may be applied to these requests (no service fee on changes resulting in no cost change).  Request can be made by clicking on the Change/Cancel/View Your Reservation link on the reservations page.  A change resulting in a lesser cost will result in a refund only if the change is requested 3 days or more before the entry date.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                Can I add guests after I’ve purchased my reservation?
              </h3>
              If it is before your reservation start time, you can return to the reservation website and purchase the appropriate number of additional entry tickets – if space if available.  You will be charged at that point for the extra visitors in your party.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                I have reservations today, but it’s raining.  Can I get a refund?
              </h3>
              No, we do not offer refunds due to the weather or any other conditions outside of our control, unless there is an official park closure due to hazardous conditions or emergency.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                I am kama’āina, do I need a reservation, and must I purchase parking and entry fees?
              </h3>
              Reservations are not required for all kamaʻāina with valid identification issued by the State of Hawaiʻi.  Proceed to the entry point and show your state of Hawaiʻi driverʻs license or I.D.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                I am a kamaʻāina and I have out of state guests with me.  Do they need a reservation?
              </h3>
              Yes, your guests require reservations and must purchase parking (if they are driving their vehicle) and/or entry tickets.  Please do not bring them to the park without confirmed reservations, as they will be denied access.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                I live in the state now, but I do not yet have a Hawaiʻi issued I.D. Do I need to make a reservation and purchase entry tickets?
              </h3>
              Yes.  Once you receive your official Hawaiʻi I.D., you will no longer need a reservation or be subject to parking and entry fees.  
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                Does my cabin, camping or camper van reservation include parking and entry into the park?
              </h3>
              Yes, your overnight reservation includes parking for your vehicle and entry for all members listed on the overnight reservation for the duration of your stay.  Therefore, separate parking and entry reservations are not needed.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
               If we purchased the 7:00a.m. to 10:00a.m. reservation period, do we need to purchase another voucher to stay until 12:00p.m.?
              </h3>
              Yes, multiple time slots can be purchased to stay at the park for an extended period.  In this situation a voucher for 7:00a.m. to 10:00a.m. and a voucher for 10:00a.m. to 12:30p.m. will be needed.
            </p>
      
            <p>
              <hr />
              <h3 className="h4 fw-bold">
                My reservation states the valid time is 10:00a.m.-12:30p.m.  Does that mean I have to leave the park by 12:30p.m.?
              </h3>
              Yes, you may enter the park anytime within your reservation valid time but must leave the park once the reservation valid time has ended.  To best experience the park, we recommend you enter as early as your reservation allows.
            </p>
            <p>
              <hr />
              <p>We hope you enjoy your visit to Waiʻānapanapa State Park!</p>
              <p>Mahalo!</p>
              <h3 className="h4 fw-bold">
                Additional Questions:
              </h3>
             Use our Live Chat to contact one of our agents about your reservation.  Live Chat hours are between 7:45a.m. and 4:30p.m. HST (Hawaii Standard Time), Monday through Friday except Holidays.  To get started click on the chat icon on the bottom right of the page.
            </p>
          </div>
        </div>
      </div>
      <SubFooter name="Waiʻānapanapa State Park" url="waianapanapa" />
    </>
  );
}
